export default "__VITE_ASSET__aFEjf4KE__"